<template>
  <div>
    <v-row v-if="listeInscriptionsEnListeAttente == null ||  listeInscriptionsEnListeAttente.length == 0">
      <v-col cols="12">
        <v-card
          outlined
          class="pa-3 cardCours"
          style="border: 2px solid #095797;min-height:125px"
        >
          <div>
            <v-card-title
              class="aucunCoursDispo"
              v-html="messageAucuneInscriptionEnListeAttente()"
            >
            </v-card-title>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        :cols="nombreCols"
        :sm="nombreCols"
        :md="nombreCols"
        :lg="nombreCols"
        v-for="cours in listeInscriptionsEnListeAttente"
        v-bind:key="cours.id"
      >
        <v-flex
          fill-height
          style="flex: 1; width: 100%"
        >
          <v-card
            outlined
            class="pa-3 cardCours infosCoursPageConfirmation"
          >
            <v-row class="columnBoiteCours py-1 infosBlocsPrixPageConfirmation">
              <v-col
                cols="7"
                style="padding-bottom: 0px"
                class="petiteInformationBoiteCours"
              >
                <label style="font-weight: bold; color: black">
                  {{ cours.codeMatiere }}
                </label>
                |
                <label>
                  {{ cours.identifiantBloc }}
                </label>
              </v-col>
              <v-col
                cols="5"
                class="petiteInformationBoiteCours text-right"
              >
                <label style="font-weight: bold; color: black">
                  {{ affichagePrix(cours) }}$ <span>{{ $t('Paiement.nonFacture')}}</span>
                </label>
              </v-col>
            </v-row>

            <!-- Titre et type de cours -->
            <v-row class="columnBoiteCours py-0">
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  style="display: block"
                  class="titreCoursLigne py-0"
                >
                  <b>{{ cours.titre }}</b>
                </label>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="py-0"
              >

                <label :class="obtenirTypeCoursClasse(cours.typeCours)">
                  {{ obtenirTypeCoursLabel(cours.typeCours, cours.estExamen) }}
                </label>
              </v-col>
            </v-row>

            <!-- Affichage des dates -->
            <v-row
              class="columnBoiteCours py-0 mt-8"
              v-if="!cours.estExamen"
            >
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  style="display: block"
                  class="py-0"
                >
                  {{ $t('Paiement.dates') }}
                </label>
                <!-- Format de la date affichée -->
                <p>{{ cours.datesHeuresBlocs.dateDebut }} au {{ cours.datesHeuresBlocs.dateFin }} | {{ cours.datesHeuresBlocs.heureDebut }} à {{ cours.datesHeuresBlocs.heureFin }}</p>
              </v-col>
            </v-row>

            <!-- Affichage description/consigne (Seulement lorsque c'est un examen) -->
            <v-row
              class="columnBoiteCours py-0 mt-8"
              v-if="cours.estExamen"
            >
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  style="display: block"
                  class="py-0"
                >
                  <b>{{ $t('Paiement.informations') }}</b>
                </label>
                <p>{{ cours.consigne }}</p>
                <p>{{ cours.description }}</p>
              </v-col>
            </v-row>

            <!-- État de l'inscription -->
            <v-row class="columnBoiteCours py-0 mt-2">
              <v-col
                cols="12"
                class="py-0"
              >
                <div style="display:flex">
                  <label
                    style="display: block"
                    class="py-0"
                  >
                    <b>{{ $t('Paiement.etatInscription') }}</b>
                  </label>
                  <label
                    style="color:#757575"
                    :class="obtenirTypeCoursClasse(cours.typeCours)"
                  >
                    <div style="margin-right:10px;margin-left:5px">
                      {{ obtenirEtatInscription(cours) }}
                    </div>
                  </label>
                </div>
              </v-col>
            </v-row>

            <!-- Position sur la liste d'attente -->
            <v-row
              class="columnBoiteCours py-0 mt-8"
              v-if="
                cours.listeAttente.estEnAttente &&
                cours.etatCoursEleveId != etatRefuse &&
                cours.listeAttente.no != etatAttentePaiement &&
                cours.etatCoursEleveId != etatAnnuleParParent &&
                cours.etatCoursEleveId != etatAnnuleParCSS
              "
            >
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  style="display: block"
                  class="py-0"
                >
                  <b>{{ $t('Paiement.noListeAttente') }}<span style="margin-left:5px">{{ cours.listeAttente.no }}</span></b>
                </label>
              </v-col>
            </v-row>

            <!-- Place non garantie -->
            <v-row
              class="columnBoiteCours py-0 mt-8"
              v-if="
                cours.listeAttente.estEnAttente &&
                cours.etatCoursEleveId != etatRefuse &&
                cours.listeAttente.no != etatAttentePaiement &&
                cours.etatCoursEleveId != etatAnnuleParParent &&
                cours.etatCoursEleveId != etatAnnuleParCSS
              "
            >
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  style="display: block"
                  class="py-0"
                >
                  <i style="font-size:18px">{{ $t('avertissement.placeNonGarantie') }}</i>
                </label>
              </v-col>
            </v-row>

            <!-- Boutons -->
            <v-row class="columnBoiteCours displayBlockPetitAffichage">
              <!-- Si ce n'est pas un examen, la desc est affichée en bas à gauche de la tuile -->
              <v-col
                :cols="determinerNombreColonnesDesc()"
                class="marginLabelDesc"
              >
                <p
                  v-if="!cours.estExamen"
                  style="color: #095797;margin-bottom:0px"
                >
                  {{ cours.description }}
                </p>
              </v-col>
              <!-- Si le cours n'est pas refusé ou annulé par parent - état 3 ou 9, les boutons s'affichent -->
              <v-col
                v-if="cours.etatCoursEleveId != etatRefuse && cours.etatCoursEleveId != etatAnnuleParParent"
                :cols="determinerNombreColonnesBoutons()"
                class="flexBoutonsPageConfirmation marginInherit"
                style="display:flex"
              >
                <!-- Bouton "Payer" (s'affiche selon les états dans etatsPourPouvoirPayer) -->
                <div
                  v-if="etatsPourPouvoirPayer.includes(cours.etatCoursEleveId)"
                  style="text-align:left"
                >
                  <v-btn
                    outlined
                    v-on:click="payer(cours)"
                    class="mb-3 ml-2 stylesBtnConfirmation longueurBoutonPageConfirmation"
                  >
                    <span v-if="cours.estGratuit || cours.etatPaiement === etatPaiement.Paye">
                      {{ $t("Paiement.inscrire") }}
                    </span>
                    <span v-else>
                      {{ $t("Paiement.payer") }}
                    </span>
                  </v-btn>
                </div>
                <!-- Bouton "Annuler l'inscription" -->
                <div v-if="cours.listeAttente.estEnAttente">
                  <v-btn
                    outlined
                    v-on:click="dialogueRetirerInscription(cours)"
                    class="mb-3 btnRetraitOuAnnulation longueurBoutonPageConfirmation marginInherit"
                    style="margin-left:8px"
                    v-if="peutAnnulerCours(cours)"
                  >
                    {{ $t("Paiement.annulation.texteBouton1") }}<br>{{ $t("Paiement.annulation.texteBouton2") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-flex>
      </v-col>
    </v-row>
    <LogiqueListes
      v-on:peutPasPayer="peutPasPayer"
      ref="logique"
    />
  </div>
</template>

<script>
import CsqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import useAppStore from '@/store/appStore';
import usePaiementStore from '@/store/paiementStore';
import {
  EtatCoursEleve, PorteeCours, ProvenanceEleve, EtatPaiement,
} from '@/outils/Enum';
import LogiqueListes from './LogiqueListes.vue';

export default {
  name: 'ListeInscriptionsListeAttente',
  setup() {
    const appStore = useAppStore();
    const paiementStore = usePaiementStore();

    return { appStore, paiementStore };
  },
  components: {
    LogiqueListes,
  },
  data() {
    return {
      estMobile: false,
      listeInscriptionsEnListeAttente: [],
      nombreCols: 0,
      etatRefuse: EtatCoursEleve.Refuser,
      etatAnnuleParParent: EtatCoursEleve.AnnulerParParent,
      etatAttentePaiement: EtatCoursEleve.EnAttentePaiement,
      etatAnnuleParCSS: EtatCoursEleve.AnnulerParCSS,
      etatPaiement: EtatPaiement,
      porteeRegionale: PorteeCours.Regional,
      etatsPourPouvoirPayer: [],
      etatsStylesBoutonsLabel: [],
      ProvenanceEleve,
    };
  },
  props: {
    listeCoursEnAttente: [],
    estUneSeuleSection: {
      type: Boolean,
      default: false,
    },
    estUneSeuleSectionAvecPlusUnCours: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    this.etatsPourPouvoirPayer = this.$refs.logique.etatsPourPouvoirPayer();

    if (window.screen.width <= 760) {
      this.estMobile = true;
    } else {
      this.estMobile = false;
    }

    const listeCoursAttente = this.listeCoursEnAttente;

    // Ajustement des sections
    if (this.estMobile) {
      this.nombreCols = 12; // Un seul cours par ligne
    } else if (this.estUneSeuleSectionAvecPlusUnCours) {
      this.nombreCols = 6; // Plusieurs cours sur une ligne
    } else if (!this.estUneSeuleSection) {
      this.nombreCols = 12; // Un seul cours par ligne
    }

    // Préparation des états pour d'autres styles
    this.etatsStylesBoutonsLabel = {
      sectionUnique: this.estUneSeuleSection,
      sectionUniqueAvecPlusieurs: this.estUneSeuleSectionAvecPlusUnCours,
    };

    // Affichage des cours sur la liste d'attente
    if (listeCoursAttente !== null && listeCoursAttente !== undefined && listeCoursAttente.length > 0) {
      // Obtention des numéros dans la liste d'attente
      const listeCoursEleveSeulement = [];
      for (let cpt = 0; cpt < listeCoursAttente.length; cpt += 1) {
        listeCoursEleveSeulement.push(listeCoursAttente[cpt].coursEleve);
      }

      // Obtention des positions dans la liste d'attente
      const definirPlaces = {
        listeCoursEleve: listeCoursEleveSeulement,
        anneeScolaire: this.appStore.modele.anneeEnSeptembre,
      };
      await this.paiementStore.definirPlaceDansListeAttenteSelonCoursCourant(definirPlaces);
      const coursEleveAvecNumeroLstAttente = this.paiementStore.coursEleveNoPlaceListeAttente;

      // Obtention de l'identifiant des blocs
      const blocsId = [];
      for (let cptBlocs = 0; cptBlocs < listeCoursAttente.length; cptBlocs += 1) {
        blocsId.push(listeCoursAttente[cptBlocs].cours.blocId);
      }

      // Définition des blocs
      const blocsDefinis = await this.definirBlocs(blocsId);

      for (let cpt = 0; cpt < listeCoursAttente.length; cpt += 1) {
        const coursCourant = listeCoursAttente[cpt];
        // Position dans la liste d'attente
        const numero = coursEleveAvecNumeroLstAttente.find((x) => x.id === coursCourant.coursEleve.id).numeroPlaceAttente;

        // Obtention du bloc du cours actuel dans la boucle
        const blocIdCourant = coursCourant.cours.blocId;
        const blocCourant = blocsDefinis.find((x) => x.id === blocIdCourant);

        const coursPaye = {
          id: coursCourant.cours.id,
          blocId: blocIdCourant,
          identifiantBloc: blocCourant.identifiant,
          prixCSSMembre: coursCourant.cours.prixCSSMembre,
          prixExterne: coursCourant.cours.prixExterne,
          prixScolarise: coursCourant.cours.prixScolarise,
          prixPrive: coursCourant.cours.prixPrive,
          codeMatiere: coursCourant.cours.codeMatiere,
          titre: coursCourant.cours.titre,
          typeCours: coursCourant.cours.typeCours,
          listeAttente: {
            estEnAttente: coursCourant.coursEleve.estListeAttente,
            no: numero != null ? numero : null,
          },
          coursEleveId: coursCourant.coursEleve.id,
          etatCoursEleveId: coursCourant.coursEleve.etat,
          etatPaiement: coursCourant.coursEleve.etatPaiement,
          description: coursCourant.cours.description,
          datesHeuresBlocs: {
            dateDebut: blocCourant.dateDebut,
            dateFin: blocCourant.dateFin,
            heureDebut: blocCourant.heureDebut,
            heureFin: blocCourant.heureFin,
          },
          estExamen: coursCourant.cours.portee !== this.porteeRegionale,
          estGratuit: coursCourant.estGratuit,
          consigne: coursCourant.cours.consigne,
          provenanceEleve: coursCourant.coursEleve.provenanceEleve,
          estScolariseMaison: coursCourant.coursEleve.estScolariseMaison,
          cssId: coursCourant.cours.cssId,
        };
        this.listeInscriptionsEnListeAttente.push(coursPaye);
      }
    } else {
      this.listeInscriptionsEnListeAttente = [];
    }
  },
  methods: {
    messageAucuneInscriptionEnListeAttente() {
      return this.$t('Paiement.listeInscriptionsListeAttente.aucuneEnAttente');
    },
    obtenirTypeCoursClasse(valeur) {
      this.$refs.logique.obtenirTypeCoursClasse(valeur);
    },
    obtenirTypeCoursLabel(valeur, estExamen) {
      return this.$refs.logique.obtenirTypeCoursLabel(valeur, estExamen);
    },
    obtenirEtatInscription(cours) {
      return this.$refs.logique.obtenirEtatInscription(cours);
    },
    correctionAffichageMobile() {
      return this.$refs.logique.correctionAffichageMobile(this.estMobile);
    },
    dialogueAnnulationInscription(cours) {
      this.$refs.logique.dialogueAnnulationInscription(cours);
    },
    dialogueRetirerInscription(cours) {
      this.$refs.logique.dialogueRetirerInscription(cours);
    },
    async payer(cours) {
      await this.$refs.logique.payer(cours);
    },
    async definirBlocs(blocsId) {
      const blocs = await this.$refs.logique.definirBlocs(blocsId);
      return blocs;
    },
    peutPasPayer(messageErreur) {
      this.$emit('peutPasPayer', messageErreur);
    },
    colonnesDependammentSections() {
      if (this.estUneSeuleSectionAvecPlusUnCours) {
        return 8;
      }
      return 4;
    },
    peutAnnulerCours(cours) {
      return this.$refs.logique.peutAnnulerCours(cours);
    },
    determinerNombreColonnesBoutons() {
      return this.$refs.logique.determinerNombreColonnesBoutons(this.etatsStylesBoutonsLabel);
    },
    determinerNombreColonnesDesc() {
      return this.$refs.logique.determinerNombreColonnesDesc(this.etatsStylesBoutonsLabel);
    },

    affichagePrix(cours) {
      // Si l'organisme offre les cours gratuits
      if (cours != null) {
        if (cours.estGratuit) {
          return 0;
        }

        if (cours.estScolariseMaison) {
          return cours.prixScolarise;
        } if (cours.provenanceEleve === this.ProvenanceEleve.CSSMonteregieEstrie) {
          return cours.prixCSSMembre;
        } if (cours.provenanceEleve === this.ProvenanceEleve.CSSExterne) {
          return cours.prixExterne;
        } if (cours.provenanceEleve === this.ProvenanceEleve.EcolePrive) {
          return cours.prixPrive;
        }
      }
      return null;
    },
  },
  computed: {
    estExterne() {
      return CsqcOutilsCoursEte.EstExterne();
    },
    estCssMembre() {
      return CsqcOutilsCoursEte.EstCSSMembre();
    },
    estCssExterne() {
      return CsqcOutilsCoursEte.EstCSSExterne();
    },
    estPrive() {
      return CsqcOutilsCoursEte.EstPrive();
    },
    estScolariseMaison() {
      return CsqcOutilsCoursEte.EstScolariseMaison();
    },
  },
};
</script>

<style scoped>
.marginInherit {
  margin: inherit;
}

.marginLabelDesc {
  margin: auto;
  margin-right: 0;
  margin-left: 0;
}
</style>
